import { defineComponent as _defineComponent } from 'vue'
import WidgetContainer from '@/components/Charts/widgetContainer/WidgetContainer.vue';
import WidgetDefinition from '@/models/Charts/widgetDefinition';
import { WidgetEnum } from '@/models/enums/WidgetEnum';
import { indexedWidgetDefinitions } from '@/utils/misc';
import { FilterTimeSpanEnum } from '@/models/enums/FilterTimeSpanEnum';
import { FilterTimeAxisSpanEnum } from '@/models/enums/FilterTimeAxisSpanEnum';
import { FlexibleLayoutGridDefinition } from '@/views/dashboard/flexible-layout-grid';
import FlexibleLayoutGrid from '@/views/dashboard/FlexibleLayoutGrid.vue';
import environment from '@/utils/environment';
import { computed } from 'vue';


/**
 * Content of the Summary tab on the Bend page.
 *
 * Receives the Bend page's filter values as props to apply them to the widgets.
 */
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'BendSummary',
  props: {
    selectedDevices: null,
    selectedTimespan: null,
    selectedShifts: null,
    selectedTimeAxisSpan: null
  },
  setup(__props: any) {

const props = __props as {
  selectedDevices: string[];
  selectedTimespan: FilterTimeSpanEnum;
  selectedShifts: number[];
  selectedTimeAxisSpan: FilterTimeAxisSpanEnum;
};



const gridLayout = new FlexibleLayoutGridDefinition([
  [3, 3, 3, 3],
  [5, 7],
  [7, 5],
]);

const widgetDefinitions = computed<WidgetDefinition[]>(() => {
  const newWidgetDefinitions = indexedWidgetDefinitions(
    [
      WidgetEnum.NumberOfBendsWidget,
      WidgetEnum.PeakHourlyBendingWidget,
      WidgetEnum.BendProductivity,
      WidgetEnum.BendProductionOutputWidget,
      WidgetEnum.BendStatusOverview,
      WidgetEnum.BendProductivityFigures,
      WidgetEnum.BendRankingOfParts,
      WidgetEnum.BendShiftStatistics,
    ].map((widgetEnum) =>
      new WidgetDefinition(
        widgetEnum,
        props.selectedDevices,
        props.selectedTimespan,
        props.selectedShifts,
        undefined,
        props.selectedTimeAxisSpan,
      ).hideInfo(),
    ),
  );

  if (!environment.isLocalDevelopmentEnvironment()) {
    // Show 'Ranking of parts' and 'Shift statistics' (the 2 last) only on local environment
    return newWidgetDefinitions.slice(0, newWidgetDefinitions.length - 2);
  }

  return newWidgetDefinitions;
});

return { __sfc: true,props, gridLayout, widgetDefinitions, WidgetContainer, FlexibleLayoutGrid }
}

})